import styled from "styled-components";

const Article = styled.article`
  text-align: ${props => (props.centered ? "center" : "auto")};
`;

export default Article;
